import { Chip } from '@shared/ui/Chip';

type QuestionChipProps = {
  id: string;
  label: string;
  active: boolean;
  onClick: (id: string) => void;
};

export const QuestionChip = ({ id, label, active, onClick }: QuestionChipProps) => {
  const handleClick = () => {
    onClick(id);
  };

  return (
    <Chip
      label={label}
      active={active}
      onClick={handleClick}
    />
  );
};
